import React from 'react'
import * as R from 'ramda'
import { isUndefined } from 'lodash'
import { connect } from 'react-redux'
import validator from 'email-validator'
import { bindActionCreators } from 'redux'
//import FacebookLogin from 'react-facebook-login'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { fetchingState } from './../helpers/hocs.js'

//import Facebook from './../components/Icons/Facebook'
import { getIsLogged } from '../selectors/user.js'
import { logIn, requestCode, clearError, confirmCode, setName, getUser, logInSocial, clearAuthData, setUserSettings, getUserSettings, addEmail } from '../store/reducers/auth.js'
import { getSettingsInfo } from '../selectors/user.js'
import Form from './../components/Form'
import Checkbox from './../components/Checkbox'
import CommunicationChannels from './../components/CommunicationChannels'

import Timer from '../components/SIgn/Timer'

import ym from 'react-yandex-metrika';
import getCID from '../helpers/getCID.js'
import { sendMindbox } from './../helpers/hocs.js'


const notifyChannel = {
  notifyPhone: 'Телефон',
  notifyEmail: 'Email',
  notifyTelegram: 'Telegram',
  notifyWhatsapp: 'WhatsApp',
  notifyFacebook: 'Facebook',
  notifySMS: 'SMS'
}

const checkFormBthState = (data, initial) => {
  const __data = { ...initial, ...data }
  return __data.agreementPersonal && __data.agreementMailing && __data.agreementTerms && (__data.name || __data.name) && (__data.surname || __data.surname) && __data.phone && __data.email && validator.validate(__data.email)
}

const SignIn = ({ auth, onAuth, stateError, confirmCode, setInfo, authData, requestCode, onFIeldChange, clearAuthData, noBody = false, socialAuth,
  disableLogin, intl, registrationLogin, setCommunicationChannels }) => (
  <div className={[ !noBody ? 'Signin__body' : '' ].join(' ')}>
    {!noBody && <h1 className='Signin__title Head'>
      {registrationLogin ? <FormattedMessage id='sign_in.registrationLogin' /> : <FormattedMessage id='sign_in.login' />}
    </h1>}

    { auth.state === 'login' && (
      <div>
        <Form placeholder={intl.formatMessage({id: 'sign_in.phone_or_mail'})} value={authData.login} onInput={onFIeldChange('login')} onSubmit={onAuth} disableBtn={disableLogin}/>
        {/*<div className='Signin__social Text'>
          <span className='Signin__social__label Small'>Или с помощью соцсетей:</span>
          <FacebookLogin
            disableMobileRedirect={true}
            // appId='827755110709605'
            appId='708966972633786'
            fields='name,email'
            cssClass='Signin__social__button'
            callback={e => socialAuth(e, 'facebook')}
            icon={<Facebook />}
            textButton=''
          />
        </div>*/}
      </div>
    )}
    { auth.state === 'confirm' && <Form placeholder={intl.formatMessage({id: 'sign_in.confirmation_code'})} value={authData.code} onInput={onFIeldChange('code')} onSubmit={confirmCode} />}
    { auth.state === 'set' && (
      <div>
      <Form placeholder={intl.formatMessage({id: 'sign_in.phone'})} value={auth.__data.phone || authData.phone}
            onInput={auth.__data.phone ? () => {} : onFIeldChange('phone')} classname="Form__field Form__field-settings" disableBtn noAutoFocus noEnter>
      </Form>
      <Form placeholder={intl.formatMessage({id: 'sign_in.name'})} value={!isUndefined(authData.name) ? authData.name : auth.__data.name}
      onInput={onFIeldChange('name')} classname="Form__field Form__field-settings" disableBtn noAutoFocus noEnter />
      <Form placeholder={intl.formatMessage({id: 'sign_in.surname'})} value={!isUndefined(authData.surname) ? authData.surname : auth.__data.surname}
      onInput={onFIeldChange('surname')} classname="Form__field Form__field-settings" disableBtn noAutoFocus noEnter />

      <Form placeholder={intl.formatMessage({id: 'sign_in.email'})} value={!isUndefined(authData.email) ? authData.email : auth.__data.email}
      onInput={onFIeldChange('email')} classname="Form__field Form__field-settings" disableBtn noAutoFocus noEnter />

      <h1 className='Signin__subtitle Head Form__field-settings'><FormattedMessage id='sign_in.preferred_methods' /></h1>

      <CommunicationChannels userSettings={authData} setUserSettings={setCommunicationChannels}></CommunicationChannels>

        {/* <Form placeholder={intl.formatMessage({id: 'sign_in.mail'})} value={auth.__data.email || authData.email} onInput={auth.__data.email ? () => {} : onFIeldChange('email')} onSubmit={setInfo} disableBtn={!checkFormBthState(authData, auth.__data)} noEnter noAutoFocus /> */}
      <Form hideInput onSubmit={setInfo} disableBtn={!checkFormBthState(authData, auth.__data)}>
        <div className='Main__founds-control Text' style={{ marginBottom: 14, marginTop: 14, fontSize: 16 }}>
          <div className='Main__control'>
            <Checkbox isLight checked={authData.agreementPersonal} onChange={onFIeldChange('agreementPersonal')} />
          </div>
          <span className='Main__control-label'>
            <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/agreement_signin.pdf' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_personal_1' />
            </a>
            {' '}
            <FormattedMessage id='sign_in.agreement_personal_2' />
            {' '}
            <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_personal_3' />
            </a>
          </span>
        </div>

        <div className='Main__founds-control Text' style={{ marginBottom: 14, marginTop: 14, fontSize: 16 }}>
          <div className='Main__control'>
            <Checkbox isLight checked={authData.agreementMailing} onChange={onFIeldChange('agreementMailing')} />
          </div>
          <span className='Main__control-label'>
            <FormattedMessage id='sign_in.agreement_mailing_1' />
            {' '}
            <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_mailing_2' />
            </a>
          </span>
        </div>

        <div className='Main__founds-control Text' style={{ marginBottom: 14, marginTop: 14, fontSize: 16 }}>
          <div className='Main__control'>
            <Checkbox isLight checked={authData.agreementTerms} onChange={onFIeldChange('agreementTerms')} />
          </div>
          <span className='Main__control-label'>
            <FormattedMessage id='sign_in.agreement_terms_1' />
            {' '}
            <a target='_blank' rel='noopener noreferrer' href='/offer' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_terms_2' />
            </a>
            {' '}
            <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_terms_3' />
            </a>
            {', '}
            <FormattedMessage id='sign_in.agreement_terms_4' />
            {' '}
            <a target='_blank' rel='noopener noreferrer' href='/policy' style={{textDecoration: "underline"}}>
              <FormattedMessage id='sign_in.agreement_terms_5' />
            </a>
          </span>
        </div>
      </Form>
      </div>
    )}

    <div className='Signin__actions'>
      {(stateError || auth.error) && <div className='Text'>{stateError || auth.error}</div>}
      { auth.state === 'confirm' && <Timer clear={clearAuthData} sendCode={requestCode.bind(this, auth.loginId)} />}
    </div>
  </div>
)

const mapStateToLogged = state => ({ isLogged: getIsLogged(state) })
const mapStateToProps = (state) => ({
  infoCommunication: getSettingsInfo(state),
  auth: state.auth
})
const mapDispatchToProps = dispatch => bindActionCreators({ logIn, clearError, requestCode, confirmCode, setName,
  getUser, logInSocial, clearAuthData, addEmail, setUserSettings, getUserSettings }, dispatch)

export const checkLogin = (value, targetType = null) => {
  // prepare type variable
  let type = null

  // test value to determine value type
  if (validator.validate(value)) type = 'email'
  else if (/^\d+$/.test(value) || (value[0] === '+' && /^\d+$/.test(value.substring(1)))) type = 'phone'

  // if type is null - return false
  if (!type) return null
  // if type === email and targetType in [ email, null ] - return true
  if (R.contains(targetType, [ null, 'email' ]) && type === 'email') return true
  // if target tyoe in phone | null - test for valid phone format
  if (R.contains(targetType, [ null, 'phone' ]) && type === 'phone') return ((value[0] === '+') && (value.length >= 12)) || ((value[0] !== '+') && (value.length >= 10))
  // default return value = false
  return false
}

//Проверка только на номер телефона
export const checkPhone = (value, targetType = null) => {

  if (!(/^\d+$/.test(value) || (value[0] === '+' && /^\d+$/.test(value.substring(1))))) return null
  return ((value[0] === '+') && (value.length >= 12)) || ((value[0] !== '+') && (value.length >= 10))
}
//Проверка только на номер телефона для админки фонда формата 7хххххххххх
export const checkPhoneFund = (value, targetType = null) => {

  if (!(/^\d+$/.test(value) || (value[0] === '+' && /^\d+$/.test(value.substring(1))))) return null
  return ((value[0] !== '+') && (value[0] !== '8') && (value.length >= 10))
}
//Проверка формата даты дд.мм.гггг
export const checkDateFormat = (value, targetType = null) => {
  let dateFormat = "^[0-3]?[0-9].[0-3]?[0-9].(?:[0-9]{2})?[0-9]{2}$"
  return value.match(dateFormat)
}

//Проверка формата инн (12 цифр)
export const checkINN = (value, targetType = null) => {
  return (value.length == 12 && !isNaN(value)) || (value.length == 10 && !isNaN(value))
}

export const checkURL = (value, targetType = null) => {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(value);
}

export const checkEmail = (value, targetType = null) => {
  // prepare type variable
  let type = null

  // test value to determine value type
  if (validator.validate(value)) type = 'email'

  // if type is null - return false
  if (!type) return null
  // if type === email and targetType in [ email, null ] - return true
  if (R.contains(targetType, [ null, 'email' ]) && type === 'email') return true
  return false
}

const mergeProps = (state, dispatch, { setStateError, authData, ...props }) => {
  const getUserAndCloseModal = async () => {
    let result = await dispatch.getUser()
    if (result === 200 && props.onClose) {
      await dispatch.getUserSettings()
      props.onClose()
    }
  }
  return {
    ...props,
    ...state,
    authData,
    getUserAndCloseModal,
    clearError: dispatch.clearError,
    clearAuthData: dispatch.clearAuthData,
    onAuth: async (login, type) => {
      if (!login || !checkLogin(login, type || null)) return setStateError(`Неверный ${type ? (type === 'email' ? 'email адрес' : 'телефон') : 'логин'}`)
      // get user id from auth state
      const userId = R.pathOr(null, [ 'auth', 'userId' ], state)
      // do logIn action
      const result = await dispatch.logIn(login, userId)
      // set button disable state to true
      props.setDisable(true)
      // return the request result
      return result
    },
    requestCode: async (loginId) => {
      if (!loginId) return
      await dispatch.requestCode(loginId)
      props.setDisable(true)
    },
    confirmCode: async (e) => {
      (e && e.preventDefault) && e.preventDefault()
      if (!state.auth.loginId || !authData.code) return
      const CID = getCID()
      let result = await dispatch.confirmCode(state.auth.loginId, authData.code, state.auth.oldUser, CID)
      if (result === 200) {
        //Яндекс Метрика
        ym('reachGoal', 'Voyti')
        getUserAndCloseModal()
      }
      else if (result === 400) {
        setStateError('Неверный проверочный код')
      }
    },
    setName: (data, code) => {
      // check for every data existence
      if (!state.auth.userId || !data.name || !data.surname) return
      // perform update
      return dispatch.setName(state.auth.userId, data, code)
    },
    socialAuth: async (e, type) => {
      let result = await dispatch.logInSocial(type, e)
      if (result === 200 && props.onClose) props.onClose()
    },
    //setUserSettings,
    setUserSettings: (data) => {
      return(props.fetchingWrap(dispatch.setUserSettings.bind(this, data), 'send'))
    },
    addEmail: (data) => {
      return(props.fetchingWrap(dispatch.addEmail.bind(this, data), 'send'))
    },
    //addEmail
  }
}

export default injectIntl(compose(
  fetchingState(),
  connect(mapStateToLogged),
  withState('stateError', 'setStateError', null),
  withState('disableLogin', 'setDisable', true),
  withState('authData', 'setAuthData', {}),
  withState('months', 'setMonths', {}),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    onFIeldChange: ({ setAuthData, authData, setDisable }) => field => value => {
      // trim value
      if (value.trim) value = value.trim()
      // if field is login - check login to be valid
      if (field === 'login') setDisable(!checkLogin(value))
      // set data
      setAuthData({ ...authData, [field]: value })
    },
    setCommunicationChannels: ({setAuthData, authData}) => field => value => {//получение данных с компонента Предпочтительные каналы связи
      setAuthData({ ...authData, [field]: value })
    },
    setInfo: ({ authData, setName, onAuth, setAuthData, getUserAndCloseModal, auth: { __data, userId }, setUserSettings, addEmail, fetchingWrap }) => async e => {
      e && e.preventDefault()
      //
      if (!checkFormBthState(authData, __data)) return
      // get last code for future profile updates
      const { code, ...rest } = authData
      rest.name = rest.name || __data.name
      rest.surname = rest.surname || __data.surname

      let settingsData = {
        notifyEmail: rest.notifyEmail || __data.notifyEmail,
        notifyPhone: rest.notifyPhone || __data.notifyPhone,
        notifySMS: rest.notifySMS || __data.notifySMS,
        notifyTelegram: rest.notifyTelegram || __data.notifyTelegram,
        notifyWhatsapp: rest.notifyWhatsapp || __data.notifyWhatsapp,
        notifyFacebook: rest.notifyFacebook || __data.notifyFacebook
      }

      const allAgreementsChecked = rest.agreementPersonal && rest.agreementMailing && rest.agreementTerms

      /**
       * короче тут такая хуйня]
       * 1. надо понять заполнил ли тут кто-то телефон или мейл
       * 2. надо понять заполнил ли кто то имя-фамилию
       * 3. сначала надо обновить имя-фамилию, потом логин.
       */
      // prepare proceed flag
      let proceed = true
      if (rest.name || rest.surname) {
        // prepare name data
        const nameData = {
          agreement: allAgreementsChecked,
          agreementPersonal: rest.agreementPersonal || false,
          agreementMailing: rest.agreementMailing || false,
          agreementTerms: rest.agreementTerms || false,
          name: rest.name || __data.name,
          surname: rest.surname || __data.surname,
          email: rest.email || __data.email
        }
        // do name update
        const result = await setName(nameData, code)
        // set proceed flag to true if result has been succesful
        proceed = result === 200 || result === 403
      }
      if (proceed) {

        if (rest.phone) await setAuthData({ ...authData, code: null })
        const result = await onAuth(rest.phone || __data.phone, 'phone')
        if (result === 200) {
          //данные для отправки аналитики mindbox при регистрации
          const communicationChannel = Object.keys(authData).filter(item => item.indexOf('notify') !== -1 && authData[item]).map(item => notifyChannel[item])
          const mindboxData = {
            "customer": {
              "ids": {
                "websiteID": userId
              },
              "lastName": rest.surname,
              "firstName": rest.name,
               "email": rest.email,
              "mobilePhone": rest.login || __data.phone,
              "customFields": {
                "communicationchannel": [...communicationChannel]
              },
              "subscriptions": [
                {
                  "brand": "Meetforcharity",
                  "pointOfContact": "Email",
                },
                {
                  "brand": "Meetforcharity",
                  "pointOfContact": "SMS",
                }
              ]
            },
            "pointOfContact": "meetforcharity-website",
          }
          //sendMindbox(mindboxData, 'registration')
          await setUserSettings(settingsData)//после создания пользователя и его входа в систему надо сохранить его настройки
          await addEmail(rest.email || __data.email)//и эл почту
          if (__data.phone) await getUserAndCloseModal()
        }
      }
    },
    onAuth: ({ authData, onAuth }) => e => {
      (e && e.preventDefault) && e.preventDefault()
      const { login } = authData
      if (!login) return

      onAuth(login)
    },
    clearAuthData: ({ clearAuthData, setAuthData, setDisable }) => e => {
      setDisable(true)
      setAuthData({})
      clearAuthData()
    }
  }),
  lifecycle({
    componentDidMount () {
      this.props.clearError()
      this.props.clearAuthData()
    },
    componentWillMount() {
      let months = {null: '\n'}//массив месяцев
      for (let i = 0; i < 12; i++) {
        months[i] = this.props.intl.formatMessage({id: 'profile_edit.birthday.' + i})
      }
      this.props.setMonths(months)
    },
    componentWillReceiveProps (np) {
      if ((np.auth.loginId !== this.props.auth.loginId) && np.auth.loginId) this.props.requestCode(np.auth.loginId)
      //отправка метрики авторизации на mindbox
      if (np.auth.user && Object.keys(np.auth.user).length > 0 && (np.infoCommunication && this.props.infoCommunication === null)) {
        //console.log('что по данным к моменту авторизацииб**********************', np)
        const communicationChannel = Object.keys(np.infoCommunication).filter(item => item.indexOf('notify') !== -1 && np.infoCommunication[item]).map(item => notifyChannel[item])
        const mindboxData = {
          customer: {
            lastName: np.auth.user.surname,
            firstName: np.auth.user.name,
            email: np.auth.user.emails[0],
            mobilePhone: np.infoCommunication.phone,
            ids: {
              websiteID: np.auth.user._id
            },
            customFields: {
              communicationchannel: [...communicationChannel],
              telegramID: np.auth.user.telegram,
              telegramName: np.auth.user.telegramName,
              birthday: `${np.auth.user.birthday} ${np.months[np.auth.user.birthmonth]}`
            },
            subscriptions: [
              {
                brand: "Meetforcharity",
                pointOfContact: "Email",
              },
              {
                brand: "Meetforcharity",
                pointOfContact: "SMS",
              }
            ]
          },
          pointOfContact: "meetforcharity-website"  
        }
        //console.log('данные на вторую отправку', mindboxData)
        sendMindbox(mindboxData, 'authorization_2')
      }
      //console.log('пропсы при авторизации***************************', np)
    },
    componentWillUnmount () {
      this.props.clearAuthData()
    }
  })
)(SignIn))

/*
  { auth.state === 'login' && (
    <div className='Signin__social Text'>
      <span className='Signin__social__label Small'>Или с помощью соцсетей:</span>

      <button type='button' className='Signin__social__button'><Vkontakte /></button>
      <button type='button' className='Signin__social__button'><Twitter /></button>
      <button type='button' className='Signin__social__button'><Odnoklassniki /></button>
    </div>
  )}
*/

// import validator from 'email-validator'
// import Twitter from './../components/Icons/Twitter'
// import Vkontakte from './../components/Icons/Vkontakte'
// import Odnoklassniki from './../components/Icons/Odnoklassniki'



// WEBPACK FOOTER //
// ./src/containers/Signin.jsx